import React, { useState } from 'react';
import { useLoaderData } from 'react-router-dom';
import AnimationScreen from '../components/AnimationScreen';
import ProgressBar from '../components/ProgressBar';
import OptionList from '../components/OptionList';
import NavigationBar from '../components/NavigationBar';
import { OptionItem, PageData } from '../types/types';

const BearingDesign: React.FC = () => {
	const { title, progress, prev, content } = useLoaderData() as PageData;
	const [ nextPage, setNextPage ] = useState<string | undefined>( undefined );

	const selectNextStep = ( option: OptionItem ) => {
		setNextPage( option.path );
	};

	return (
		<AnimationScreen>
			<ProgressBar progress={progress} />
			<h3>{title}</h3>
			<p className="c-guided-help__description"
				dangerouslySetInnerHTML={{
					__html: `
						${ content.description }&nbsp;
						${ content.learnMore ? `
							<a 
								class="btn btn--tertiary" 
								href=${ content.learnMore.url } 
								data-link-click
							>
								${ content.learnMore.label }
							</a>
						` : '' }
					`,
				}} />
			{content.options && (
				<OptionList
					options={content.options}
					onSelect={selectNextStep}
					columns={3}
				/>
			)}
			<NavigationBar prev={prev} next={nextPage} />
		</AnimationScreen>
	);
};

export default BearingDesign;
